<template>
  <div class="vtMiniMain">
    <div class="vtMiniHeader">{{title}} 
      <div class="vtMiniControls">
        <button class="vtMiniBtn" @click="vtMiniBtnClick('close')">Close</button>
        <button class="vtMiniBtn" @click="vtMiniBtnClick('save')">Save</button>
      </div> 
    </div>

    <div class="vtMiniTop">
      <div class="vtMiniDetailsMain">
        <div class="vtMiniCol vtMiniTitle">
          <div class="vtMiniRow">Consignment No</div>
          <div class="vtMiniRow">Container No</div>
          <div class="vtMiniRow">SzTyp / Hdg / Del</div>
        </div>
        <div class="vtMiniCol vtMiniRowValue">
          <div class="vtMiniRow">{{data['Consignment #']}}</div>
          <div class="vtMiniRow">{{data['Container #']}}</div>
          <div class="vtMiniRow">{{data['Sz/Ty'] + ' / ' + data['Hdg'] + ' / ' + data['Del']}}</div>
        </div>
      </div>
      <div class="vtMiniDetailsMain vtRightCol">
        <Input placeholder="Seal No" :inputValue.sync="sealNoItem"/>
        <RemarksBox title="Remarks" :text.sync="remarksItem"/>
      </div>
      <div class="vtMiniDateMain">
        <div class="vtMiniCol vtMiniDate">
          <!-- <div class="vtMiniRow"> <DateTime class="vtMiniDateItem" title="Est. Departure Time" :value.sync="iETD" /> </div>
          <div class="vtMiniRow"> <DateTime class="vtMiniDateItem" title="Est. Arrival Time" :value.sync="iETA" /> </div> -->
        </div>
      </div>
    </div>

    <div class="vtMiniBottom">
      <div class="vtMiniBottomCol">
        <div class="vtMiniBottomTitle">Assign PM</div>
        <div class="vtMiniBottomRow">
          <Dropdown placeholder="Prime Mover" :items.sync="mtPersistentData['assignPM']" itemKey="desc" :isRequired="true"
                    :selectedObject.sync="selectedPM" @selected="assignSelected" />
        </div>
        <div class="vtMiniBottomRow"> <Validator vldTitle="Availability" :vldValue="!selectedPM ? '-' : selectedPM['Availability']" 
          :vldValid="!selectedPM ? false : (selectedPM['Availability'] == 1)" /> </div>
        <div class="vtMiniBottomRow"> <Validator vldTitle="Road Tax" :vldValue="!selectedPM ? '-' : selectedPM['RoadTaxExpiryDate']" 
          :vldValid="!selectedPM ? false : checkExpired(selectedPM['RoadTaxExpiryDate'])" /> </div>
        <div class="vtMiniBottomRow"> <Validator vldTitle="Inspection" :vldValue="!selectedPM ? '-' : selectedPM['InspectionDate']" 
          :vldValid="!selectedPM ? false : checkExpired(selectedPM['InspectionDate'])" /> </div>
        <div class="vtMiniBottomRow"> <Validator vldTitle="Permit" :vldValue="!selectedPM ? '-' : selectedPM['PermitExpiryDate']" 
          :vldValid="!selectedPM ? false : checkExpired(selectedPM['PermitExpiryDate'])" /> </div>
        <div class="vtMiniBottomRow"> <Input placeholder="Trailer No" :inputValue.sync="trailerNoItem"/> </div>
      </div>
      <div class="vtMiniBottomCol" :style="{ 'margin' : '0 4px' }">
        <div class="vtMiniBottomTitle">Assign Driver</div>
        <div class="vtMiniBottomRow"> 
          <Dropdown placeholder="Driver" :items.sync="mtPersistentData['assignDriver']" itemKey="desc" :isRequired="true" 
                    :selectedObject.sync="selectedDriver" @selected="assignSelected"/> 
        </div>
        <div class="vtMiniBottomRow"> <Validator vldTitle="Driver License" :vldValue="!selectedDriver ? '-' : selectedDriver['DrvLicenseExpiryDate']" 
          :vldValid="!selectedPM ? false :  checkExpired(selectedDriver['DrvLicenseExpiryDate'])" /> </div>
        <div class="vtMiniBottomRow"> <Validator vldTitle="Badge License" :vldValue="!selectedDriver ? '-' : selectedDriver['BadgeLicenseExpiryDate']" 
          :vldValid="!selectedPM ? false :  checkExpired(selectedDriver['BadgeLicenseExpiryDate'])" /> </div>
        <div class="vtMiniBottomRow"> <Validator vldTitle="Port Pass" :vldValue="!selectedDriver ? '-' : selectedDriver['PortPassExpiryDate']" 
          :vldValid="!selectedPM ? false : checkExpired(selectedDriver['PortPassExpiryDate'])" /> </div>
      </div>
      <div class="vtMiniBottomCol">
        <div class="vtMiniBottomTitle">Assign Movement</div>
        <div class="vtMiniBottomRow"> 
          <Dropdown placeholder="Movement" :items.sync="mtPersistentData['assignMovement']" itemKey="desc" :isRequired="true" 
                    :selectedObject.sync="selectedMovement" @selected="assignSelected"/> 
          <Dropdown placeholder="From" :items="mtPersistentData['assignFromTo']" itemKey="desc"
                            :selectedObject.sync="selectedFrom" @selected="assignSelected"/>
          <Dropdown placeholder="To" :items="mtPersistentData['assignFromTo']" itemKey="desc"
                            :selectedObject.sync="selectedTo" @selected="assignSelected"/>
          <DateTime class="vtMiniDateItem" title="ETD" :value.sync="iETD" />
          <DateTime class="vtMiniDateItem" title="ETA" :value.sync="iETA" />
        </div>
      </div>
    </div>

    <div class="vtMiniFooter">
      <div class="vtMiniFooterMsg" :style="{ 'background-color' : (mtErrorColor ? mtErrorColor : '') }">{{mtErrorMsg}}</div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import DateTime from '@/components/DateTimePicker.vue';
  import Dropdown from '@/components/Dropdown.vue';
  import Input from '@/components/Input.vue';
  import InputQuery from '@/components/InputQuery.vue';
  import RemarksBox from '@/components/RemarksBox.vue';
  import Validator from '@/components/VehicleTracker/SubComponents/Validator.vue';  

  export default {
    components: {
      DateTime, Dropdown, Input, InputQuery, RemarksBox, Validator,
    },
    props: {
      title: { type: String, default: '' },
      data: { type: Object, default: function () { return {}; } },

      //-------- Information Props
      iETD: { type: Date, default: function () { return new Date; } },
      iETA: { type: Date, default: function () { return new Date; } },

      //-------- Mini Tab Props
      mtPersistentData: { type: Object, default: function () { return {}; } },
      selectedPM: { type: Object, default: function () { return {}; } },
      selectedDriver: { type: Object, default: function () { return {}; } },
      selectedMovement: { type: Object, default: function () { return {}; } },
      selectedFrom: { type: Object, default: function () { return {}; } },
      selectedTo: { type: Object, default: function () { return {}; } },
      mtErrorMsg: { type: String, default: '' },
      mtErrorColor: { type: String, default: '' },
      sealNoItem: { type: String, default: '' },
      remarksItem: { type: String, default: '' },
      trailerNoItem: { type: String, default: '' },
    },
    mounted() {
      this.vtMiniGetData();
      this.sealNoItem = !this.data['Seal No'] ? '' : this.data['Seal No'];
      this.remarksItem = !this.data['Remarks'] ? '' : this.data['Remarks'];
      this.trailerNoItem = !this.data['Remarks'] ? '' : this.data['Remarks'];
    },
    methods: {
      vtMiniGetData: async function () {
        //-------- Prime Mover
        try {
          var assignPM = await this.$apiCallV2(`/VehicleTracker/GetVehicleListByCategory`);
          //console.log(assignPM['data']);
          var assignPMF = [];
          if (Array.isArray(assignPM['data'])) {
            assignPM['data'].forEach((pm) => {
              assignPMF.push({
                'type': 'PM',
                'VehicleNo': !pm['VehicleNo'] ? '' : pm['VehicleNo'].trim(),
                'VehicleCode': !pm['VehicleCode'] ? '' : pm['VehicleCode'].trim(),
                'Availability': !pm['Availability'] ? '' : pm['Availability'].trim(),
                'RoadTaxExpiryDate': !pm['RoadTaxExpiryDate'] ? '' : this.formatDatetoString(pm['RoadTaxExpiryDate'].trim()),
                'InspectionDate': !pm['InspectionDate'] ? '' : this.formatDatetoString(pm['InspectionDate'].trim()),
                'PermitExpiryDate': !pm['PermitExpiryDate'] ? '' : this.formatDatetoString(pm['PermitExpiryDate'].trim()),
                'desc': !pm['VehicleNo'] ? '' : !pm['VehicleCode'] ? '' : (pm['VehicleNo'].trim() + ' - ' + pm['VehicleCode'].trim()),
              });
            });
          } else { console.log(assignPM) }
          this.$set(this.mtPersistentData, 'assignPM', assignPMF);
          this.$set(this.mtPersistentData, 'assignPMRaw', assignPM['data']);
        } catch (e) { console.log(e); }
        //-------- Driver
        try {
          var assignDriver = await this.$apiCallV2(`/VehicleTracker/GetEmployeeListByDepartment`);
          //console.log(assignDriver['data']);
          var assignDriverF = [];
          if (Array.isArray(assignDriver['data'])) {
            assignDriver['data'].forEach((d) => {
              assignDriverF.push({
                'type' : 'D',
                'Staff_No': !d['Staff_No'] ? '' : d['Staff_No'].trim(),
                'Staff_Name': !d['Staff_Name'] ? '' : d['Staff_Name'].trim(),
                'DrvLicenseExpiryDate': !d['DrvLicenseExpiryDate'] ? '' : this.formatDatetoString(d['DrvLicenseExpiryDate'].trim()),
                'BadgeLicenseExpiryDate': !d['BadgeLicenseExpiryDate'] ? '' : this.formatDatetoString(d['BadgeLicenseExpiryDate'].trim()),
                'PortPassExpiryDate': !d['PortPassExpiryDate'] ? '' : this.formatDatetoString(d['PortPassExpiryDate'].trim()),
                'desc': !d['Staff_No'] ? '' : !d['Staff_Name'] ? '' : (d['Staff_No'].trim() + ' - ' + d['Staff_Name'].trim()),
              });
            });
          }
          this.$set(this.mtPersistentData, 'assignDriver', assignDriverF);
          this.$set(this.mtPersistentData, 'assignDriverRaw', assignDriver['data']);
        } catch (e) { console.log(e); }
        //-------- Movement
        try {
          var assignMovement = await this.$apiCallV2(`/VehicleTracker/GetMovementType?cnno=` + this.data['Consignment #']);
          //console.log(assignMovement['data']);
          var assignMovementF = [];
          if (Array.isArray(assignMovement['data'])) {
            assignMovement['data'].forEach((m) => {
              assignMovementF.push({
                'type' : 'M',
                'MovementType': !m['MovementType'] ? '' : m['MovementType'].trim(),
                'MovementTypeDesc': !m['MovementTypeDesc'] ? '' : m['MovementTypeDesc'].trim(),
                'desc': !m['MovementType'] ? '' : !m['MovementTypeDesc'] ? '' : (m['MovementType'].trim() + ' - ' + m['MovementTypeDesc'].trim()),
              });
            });
          }
          this.$set(this.mtPersistentData, 'assignMovement', assignMovementF);
          this.$set(this.mtPersistentData, 'assignMovementRaw', assignMovement['data']);
        } catch (e) { console.log(e); }

        //-------- From / To
        try {
          var assignFromTo = await this.$apiCallV2(`/VehicleTracker/GetListMaster?master=destination&module=FMS`);
          //console.log(assignFromTo);
          var assignFromToF = [];
          if (Array.isArray(assignFromTo['data'])) {
            assignFromTo['data'].forEach((ft) => {
              assignFromToF.push({
                'type': 'FT',
                'Dest Code': !ft['Destination Code'] ? '' : ft['Destination Code'].trim(),
                'Area Code': !ft['Area Code'] ? '' : ft['Area Code'].trim(),
                'Area Name': !ft['Area Name'] ? '' : ft['Area Name'].trim(),
                'Address': !ft['Address'] ? '' : ft['Address'].trim(),
                'Post Code': !ft['PostCode'] ? '' : ft['PostCode'].trim(),
                'City': !ft['City'] ? '' : ft['City'].trim(),
                'Company': !ft['Company'] ? '' : ft['Company'].trim(),
                'Latitude': !ft['Latitude'] ? '' : ft['Latitude'].trim(),
                'Longitude': !ft['Longitude'] ? '' : ft['Longitude'].trim(),
                'desc': !ft['Destination Code'] ? '' : ft['Destination Code'].trim() + (!ft['City'] ? '' : ' - ' + ft['City'].trim()),
              });
            });
          }
          this.$set(this.mtPersistentData, 'assignFromTo', assignFromToF);
          this.$set(this.mtPersistentData, 'assignFromToRaw', assignFromTo['data']);
          var fromItem = this.mtPersistentData['assignFromTo'].filter((ft) => { return ft['Dest Code'] == this.data['Pickup'].trim() });
          if (fromItem.length > 0) { this.selectedFrom = fromItem[0] }
          console.log(fromItem);
          var toItem = this.mtPersistentData['assignFromTo'].filter((ft) => { return ft['Dest Code'] == this.data['Dropoff'].trim() });
          if (toItem.length > 0) { this.selectedTo = toItem[0] }
        } catch (e) { console.log(e); }

      },
      vtMiniBtnClick: async function (btn) {
        switch (btn) {
          case 'close':
            this.$emit('mtClose', this.title);
            break;
          case 'save':
            //console.log('save click');
            //console.log(this.data);
            var assignData = {
              'VehicleCode': !this.selectedPM['VehicleCode'] ? '' : this.selectedPM['VehicleCode'].trim(),
              'Staff_No': !this.selectedDriver['Staff_No'] ? '' : this.selectedDriver['Staff_No'].trim(),
              'MovementType': !this.selectedMovement['MovementType'] ? '' : this.selectedMovement['MovementType'].trim(),
              'JIDate': !this.iETD ? '' : this.formatDatetoString(this.iETD).split(' ')[0],
              'CN': !this.data['Consignment #'] ? '' : this.data['Consignment #'].trim(),
              'B2BCN': '',
              'SealNo': !this.sealNoItem ? '' : this.sealNoItem.trim(),
              'DepartureCode': !this.selectedFrom ? '' : this.selectedFrom['Dest Code'].trim(),
              'DestinationCode': !this.selectedTo ? '' : this.selectedTo['Dest Code'].trim(),
              'EstDepartTime': !this.iETD ? '' : this.formatDatetoString(this.iETD) + ':00',
              'EstArriveTime': !this.iETA ? '' : this.formatDatetoString(this.iETA) + ':00',
              'TrCode': !this.trailerNoItem ? '' : this.trailerNoItem.trim(),
              'Remarks': !this.remarksItem ? '' : this.remarksItem.trim(),
              'UserID': '',
              'DateUpdated': '',
              'DeviceID': '',
              'MobileNo': '',
              'GPSLatitude': '',
              'GPSLongitude': '',
            };

            console.log(assignData);

            try {
              var assignR = await this.$apiCallV2(`/VehicleTracker/HMSAssignTrip`, assignData);
              if (Array.isArray(assignR['data'])) {
              if (assignR['data'][0]['Results'] > 0) {
                this.mtErrorMsg = assignR['data'][0]['ErrMsg']; this.mtErrorColor = 'rgba(255, 121, 121, 0.37)';
              } else {
                this.mtErrorMsg = 'Assign successful'; this.mtErrorColor = '';
              }
            } else { this.mtErrorMsg = assignR['data']; this.mtErrorColor = 'rgba(255, 121, 121, 0.37)'; }
            } catch (e) { console.log(e); }
            break;
        }
      },
      //-------- Assign Methods
      assignSelected: function (data) {
        switch (data['type']) {
          case 'PM':
            console.log(this.selectedPM);
            break;
          case 'D':
            console.log(this.selectedDriver);
            break;
          case 'M':
            console.log(this.selectedMovement);
            break;
          case 'FT':
            break;
        }
      },
      //-------- Utility Methods
      formatDatetoString: function (date) {
        if (typeof date == 'string') {
          var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '');
          try {
            var dateFF = new Date(dateF);
            if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
          } catch (e) { /*console.log(e);*/ }
        } else {
          var dateFF = date;
        }
      
        var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
        var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
        var y = dateFF.getFullYear();
        var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
        var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

        return `${y}-${m}-${d} ${hh}:${mm}`;
      },
      formatStringtoDate: function (date) {
        var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
        var dateFF = dateF.split('/');
        return new Date(dateFF[0]);
      },
      checkExpired: function (date) {
        return (!date ? false : (this.formatStringtoDate(date) >= Date.now()))
      },
    },
    watch: {
      data: { deep: true, handler(h) { console.log(this.data); } },
    },
  }
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.vtMiniMain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.vtMiniHeader {
  width: 100%;
  height: 30px;
  padding: 0 4px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e6e6e6;
  border-radius: 3px 3px 0 0;
}

.vtMiniControls {
  width: auto;
  height: 100%;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtMiniBtn {
  width: auto;
  height: 100%;
  margin: 0 0 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vtMiniTop {
  width: 100%;
  height: auto;
  padding: 0 4px;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtMiniDetailsMain {
  width: 50%;
  height: 100%;
  margin: 0 5px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtRightCol {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.vtMiniCol {
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.vtMiniRow {
  width: auto;
  height: auto;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vtMiniRowValue {
  flex: 1;
}

.vtMiniTitle {
  margin: 0 10px 0 0;
  font-weight: bold;
}

.vtMiniDateMain {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtMiniDate {
  align-items: flex-end;
}

.vtMiniDateItem {
  width: 100%;
  height: 100%;
  font-size: 12px;
}

.vtMiniBottom {
  width: 100%;
  height: auto;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-y: scroll;
  overflow-x: hidden;
}

.vtMiniBottomTitle {
  width: 100%;
  height: 20px;
  padding: 0 4px;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #e6e6e6;
}

.vtMiniBottomCol {
  width: auto;
  height: 100%;
  flex: 1;
}

.vtMiniBottomRow {
  width: 100%;
  height: auto;
  padding: 0 4px;
}

.vtMiniFooter {
  width: 100%;
  height: 30px;
  padding: 2px;
  border-radius: 0 0 3px 3px;
}

.vtMiniFooterMsg {
  width: 100%;
  height: 100%;
  padding: 0 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: rgba(255, 246, 121, 0.37);
  border: solid 1px #0004;
}
</style>